import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import TableJobApply from './TableJobApply';
import SearchForm from './SearchForm';
import moment from 'moment';

export default class JobApplys extends Component {

    constructor(props) {
        super(props)
        this.state = {
            jobApplys: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            from: '',
            to: '',
            total: '',
        }
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/houjin/jobapplys/search', key).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                jobApplys: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
    }

    /**
     * Init data and form job or list jobApplys
     */
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}');
        }

        //always get list data
        axios.post('/api/houjin/jobapplys/search', keySearch_arr).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                jobApplys: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
    }

    /**
     * Prepare render jobs
     */
    prepareRender(response) {
        response.map((job) => {
            if (job.work_start_time == '00:00:00' && job.work_end_time == '23:59:00') {
                job.work_date_time = '時間指定なし';
            }
        })
    }

    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/houjin/jobapplys/search', newSearchConditions).then(response => {
            this.prepareRender(response.data.data);
            this.setState({
                jobApplys: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }

    /**
     * Edit job
     * job: Object Client
     */
    handleEdit(job) {
        this.props.history.push('/houjin/jobapplys/edit/' + job.id);
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    render() {
        const option = {
            1:{text:'採用',classHTML:'text-teal'},
            2:{text:'不採用',classHTML:'text-pink'},
            3:{text:'欠勤',classHTML:'text-yellows'},
            9:{text:'応募キャンセル',classHTML:'text-gray'},
            null:{text:'未決定',classHTML:'text-gray'}
        };
        const work_result_option = {
            1:{text:'通常勤務',classHTML:'text-teal'},
            2:{text:'残業',classHTML:'text-pink'},
            7:{text:'遅刻',classHTML:'text-pink'},
            8:{text:'早退',classHTML:'text-pink'},
            9:{text:'欠勤',classHTML:'text-pink'},
            null:{text:'未決定',classHTML:'text-gray'}
        };
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text'},
            {name: 'job_id', title: '依頼ID', isSort: 1, type: 'text'},
            // {name: 'categories_name', title: '依頼名', isSort: 1, type: 'text_break_line', isSearch:true},
            {name: 'staffs_first_last_name', title: 'ワーカー名 ', isSort: 1, type: 'text'},
            {name: 'staff_confirmed_at', title: '本人認証 ', isSort: 0, type: 'confirmed_at'},
            {name: 'birthday', title: '年齢', isSort: 1, type: 'age', prefix: "", suffix: "歳",},
            {name: 'pref', title: '都道府県', isSort: 1, type: 'text'},
            {name: 'city', title: '市区', isSort: 1, type: 'text'},
            {name: 'work_date_time', title: '勤務日時', isSort: 1, type: 'text_break_line', isSearch:true},
            {name: 'status', title: '状態', isSort: 1, type: 'status_option', option:option},
            {name: 'created_at', title: '応募日', isSort: 1, type: 'date_time'},
            {name: 'staff_price', title: '報酬', isSort: 1, type: 'convert_to_number_with_zero', prefix: '¥', prefix_price_zero: '¥'},
            // {name: 'evaluation_client', title: '依頼者評価', isSort: 1, type: 'text'},
            {name: 'evaluation_staff', title: 'ワーカー評価', isSort: 1, type: 'text'},
            {name: 'work_result', title: '勤務結果', isSort: 1, type: 'status_option', option:work_result_option},
            {name: 'client_memo', title: 'メモ', isSort: 0, type: 'text_limit'},
            {name: '', title: '', isSort: 0, type: 'filting'},
        ]
        return (
            <React.Fragment>
                <div className="row">
                   <div className="col-sm-12">
                       <nav aria-label="breadcrumb">
                           <ol className="breadcrumb mb-0">
                               <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/houjin/home">ダッシュボード</a></li>
                               <li className="breadcrumb-item active" aria-current="page">応募一覧</li>
                           </ol>
                       </nav>
                   </div>
                </div>
                <main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">応募一覧</h4>
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search_apply" aria-expanded="false" aria-controls="search_apply">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch}/>
                                        </div>
                                    </div>
                                </div>
                                <TableJobApply onSearch={this.handleSearch} onEdit={this.handleEdit} header={columns} data={this.state.jobApplys} from={this.state.from} to={this.state.to} total={this.state.total}
                                    myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} onSort={this.handleSort} />
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        );
    }
}
